<template>
    <transition name="modal-fade">
        <div class="modal-backdrop2" role="dialog">
            <div class="modal" ref="modal">
                <div class="wrap-login100">
                    <div class="login100-form validate-form">
                        <div class="closeWrap">
                            <a class="closeBtn" @click="close" aria-label="Close modal"><i class="fas fa-times"></i></a>
                        </div>
                        <div class="refTitleWrap">
                                <span class="login100-form-title">Are you sure?</span>
                               
                            </div>
                        <p>You should only change your email if it does not match your Kickstarter email. Changing your email will generate a new link and points will not carry over to the new email. Are you sure you want to change your email?
                               </p>
				    	<div class="container-login100-form-btn">
						    <button class="login100-form-btn" @click="newEmail()"> 
							   Proceed
                                <i class="fa arrow-right" aria-hidden="true"></i>
						    </button>
					    </div>
				    </div>
			    </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Router from '../../router';
export default {
    name: 'modal',
    data: function() {
    return {
        email: "",
        pledgeTier: "",
        shortUrl: ""
    };
  },
  computed: {
    
  },
  methods: {
    close() {
        document.querySelector('.modal-backdrop2').style.display = "none";
        this.$emit('close');
    },
    eraseCookie(name){
        document.cookie = `${name}= ; expires = Thu, 01 Jan 1970 00:00:00 GMT;path=/;`
        console.log(name);
    },
    newEmail(){
        this.eraseCookie("refProgramId");
        Router.push('/referral');
        
    }
  },
}
</script>


<style scoped>
.refTitleWrap span.login100-form-title {
    margin-top: 0;
    padding-bottom: 0;
    color: #fff;
}
.refTitleWrap p {
    color: #fff;
    margin: 0;
    line-height: 1.4;
    font-size: 14px !important;
    max-width: 528px;
    margin: auto;
}
.refTitleWrap {
   margin-bottom: 20px;
    width: 100%;
    text-align: center;
    max-width: 586px;
    background: linear-gradient(to right, #10264c, #123e71);
    border-radius: 10px 10px 0px 0px;
    padding: 22px;
    position: relative;
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
}
.refTitleWrap h2 {
    font-family: 'Titillium Web', sans-serif;
    font-size: 32px;
    color: #fff;
    margin-top: 0;
    margin-bottom: 10px;
    text-shadow: 1px 1px 2px #1a3b84;
}
a.closeBtn {
    font-size: 23px;
    position: absolute;
    cursor: pointer;
    right: -6px;
    top: -6px;
    color: #ffffff;
    background: #113e70;
    z-index: 9;
    padding: 5px 9px;
    line-height: 1;
    border-radius: 30px;
}
.closeWrap {
    position: relative;
}
select#tiers {
    font-size: 15px;
    border: none;
    line-height: 1.5;
    color: #666666;
    display: block;
    width: 100%;
    background: #e6e6e663;
    border-bottom: 1px solid #1dd18b;
    height: 50px;
    border-radius: 25px;
    padding: 0 30px 0 30px;
}
 .modal-backdrop2 {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modal {
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
  }
  .modal-fade-enter,
  .modal-fade-leave-active {
    opacity: 0;
  }

  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: opacity .5s ease
  }
.limiter {
    width: 100%;
    margin: 0 auto;
}
.login100-pic {
   width: 100%;
    max-width: 600px;
}
.container-login100 {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 15px;
    background: #9053c7;
    background: linear-gradient(-135deg, #2a5384, #4297c6);
}
.wrap-login100 {
    width: 100%;
    border-radius: 10px;
    height: 100%;
    align-content: center;
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
}
.login100-pic img {
    max-width: 100%;
}
.login100-form{
    padding: 21px 0px;
    width: 586px;
    background: #fff;
    border-radius: 10px;
    height: auto;
    padding-top: 0;
}
.login100-form-title {
    font-family: Digitalt;
    font-size: 36px;
    color: #333333;
    line-height: 1.2;
    text-align: center;
    width: 100%;
    margin-top: 28px;
    display: block;
    padding-bottom: 25px;
}
.input100 {
font-size: 15px;
    border: none;
    line-height: 1.5;
    color: #666666;
    display: block;
    width: 100%;
    background: #e6e6e663;
    border-bottom: 1px solid #1dd18b;
    height: 50px;
    border-radius: 25px;
    padding: 0 30px 0 30px;
}
.focus-input100 {
    display: block;
    position: absolute;
    border-radius: 25px;
    bottom: 0;
    left: 0;
    z-index: -1;
    width: 100%;
    height: 100%;
    box-shadow: 0px 0px 0px 0px;
    color: rgba(87,184,70, 0.8);
}
.symbol-input100 {
    font-size: 15px;
    display: flex;
    align-items: center;
    position: absolute;
    border-radius: 25px;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding-left: 35px;
    pointer-events: none;
    color: #666666;
    transition: all 0.4s;
}
.validate-input {
    position: relative;
}
.wrap-input100 {
    position: relative;
    width: 100%;
    z-index: 1;
    margin-bottom: 10px;
    max-width: 500px;
    margin: 10px auto;
}
.login100-form-btn {
     font-family: Digitalt;
         margin-top: 15px;
       font-size: 25px;
    border: none;
    line-height: 1.5;
    color: #fff;
    text-transform: uppercase;
    width: 100%;
    height: 44px;
    border-radius: 36px;
    background: linear-gradient(-135deg, #1fd28d, #05ce78);
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    align-items: center;
    max-width: 500px;
        margin: auto;
    padding: 0 25px;
    transition: all 0.4s;
    box-shadow: 7px 7px 28px 0 rgb(0 0 0 / 21%);
}

.steps li.is-active {
    border-bottom: 1px solid #3498db;
    color: #3498db;
}
.modal p {
    font-size: 16px;
    max-width: 84%;
    margin: auto;
    margin-top: 15px;
    color: #9a9a9a;
    margin-bottom: 18px;
    text-align: left;
}
select::-ms-expand {
    display: none;
}
.ui-select{width: 100%}
/* This is to remove the arrow of select element in IE */
select::-ms-expand {	display: none; }
select{
    -webkit-appearance: none;
    appearance: none;
}
@-moz-document url-prefix(){
	.ui-select{border: 1px solid #CCC; border-radius: 4px; box-sizing: border-box; position: relative; overflow: hidden;}
  .ui-select select { width: 110%; background-position: right 30px center !important; border: none !important;}
}
i.fas.fa-chevron-down {
    position: absolute;
    right: 22px;
    top: 18px;
    font-size: 17px;
    color: #abc0d8;
}
a.newEmail {
    display: block;
    font-weight: 500;
    cursor: pointer;
    color: #337ab7;
}

@media only screen and (max-width: 605px) {
    .login100-form{
        width: 90%;
        max-width: 586px;
        padding-bottom: 30px;
        height: auto;
    }
    .wrap-input100.validate-input {
        width: 90%;
    }
    button.login100-form-btn {
        width: 90%;
    }
}
.rwd-table {
  margin: 1em 0;
  min-width: 300px;
}
.rwd-table tr {
  border-bottom: 1px solid #ddd;
}
.rwd-table th {
  display: none;
  font-size: 17px !important;
}
.rwd-table td {
  display: block;
}
.rwd-table td:first-child {
  padding-top: .5em;
}
.rwd-table td:last-child {
  padding-bottom: .5em;
}
.rwd-table td:before {
  content: attr(data-th) ": ";
  font-weight: bold;
  width: 6.5em;
  display: inline-block;
}
@media (min-width: 480px) {
  .rwd-table td:before {
    display: none;
  }
}
.rwd-table th, .rwd-table td {
  text-align: center;
}
@media (min-width: 480px) {
  .rwd-table th, .rwd-table td {
    display: table-cell;
    padding: .25em .5em;
  }
  .rwd-table th:first-child, .rwd-table td:first-child {
    padding-left: 0;
  }
  .rwd-table th:last-child, .rwd-table td:last-child {
    padding-right: 0;
  }
}





.rwd-table {
    background: #ffffff;
    color: #fff;
    border-radius: .4em;
    overflow: hidden;
    width: 100%;
    max-width: 300px;
    margin: auto;
    font-family: 'Titillium Web', sans-serif;
    margin-bottom: 20px !important;
}
.rwd-table tr {
      border-color: rgb(48 133 214 / 29%);
}
.rwd-table th, .rwd-table td {
     margin: .5em 1em;
    font-size: 14px;
    color: #123c6d;
}
@media (min-width: 480px) {
  .rwd-table th, .rwd-table td {
   padding: 0.5em .5em !important;
  }
}
.rwd-table th, .rwd-table td:before {
  color: #113d6e;
}
.rwd-table tr:nth-child(1) {
    border-color: #113867;
}
.rwd-table tr:first-child {
    border-top: none;
}
.rwd-table tr:last-child {
    border-bottom: none;
}
</style>


// WEBPACK FOOTER //
// src/views/Referral/NewEmailModal.vue